import React, { useState } from 'react'
import styled from 'styled-components'
import { Container, Wrapper, Title, Desc, CardContainer, ToggleButtonGroup, ToggleButton, Divider } from './ProjectsStyle'
import ProjectCard from '../Cards/ProjectCards'
import { projects } from '../../data/constants'
import useScrollReveal from '../../hooks/useScrollReveal'

const INITIAL_SHOW = 3;

const filterOptions = [
    { value: 'all', label: 'All' },
    { value: 'web app', label: 'Web Apps' },
    { value: 'devops', label: 'DevOps' },
];

const RevealCard = styled.div`
    width: 100%;
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    transform: translateY(${({ $visible }) => ($visible ? '0' : '30px')});
    transition: opacity 0.55s cubic-bezier(0.22, 1, 0.36, 1),
                transform 0.55s cubic-bezier(0.22, 1, 0.36, 1);
    transition-delay: ${({ $delay }) => $delay || '0s'};
`

const ShowMoreButton = styled.button`
    margin-top: 8px;
    padding: 12px 36px;
    border-radius: 50px;
    border: 1.5px solid ${({ theme }) => theme.primary};
    background: transparent;
    color: ${({ theme }) => theme.primary};
    font-size: 15px;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    letter-spacing: 0.3px;
    transition: all 0.3s ease;

    &:hover {
        background: ${({ theme }) => theme.primary};
        color: #fff;
        box-shadow: 0 4px 24px ${({ theme }) => theme.primary_glow};
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }
`

const ProjectCount = styled.div`
    font-size: 13px;
    color: ${({ theme }) => theme.text_tertiary};
    margin-top: 4px;
`

const AnimatedCard = ({ project, setOpenModal, index }) => {
    const [ref, isVisible] = useScrollReveal({ threshold: 0.1 })
    return (
        <RevealCard ref={ref} $visible={isVisible} $delay={`${index * 0.1}s`}>
            <ProjectCard project={project} setOpenModal={setOpenModal} />
        </RevealCard>
    )
}

const Projects = ({ openModal, setOpenModal }) => {
    const [toggle, setToggle] = useState('all');
    const [showAll, setShowAll] = useState(false);

    const filteredProjects = toggle === 'all'
        ? projects
        : projects.filter((item) => item.category === toggle);

    const visibleProjects = showAll ? filteredProjects : filteredProjects.slice(0, INITIAL_SHOW);
    const hiddenCount = filteredProjects.length - INITIAL_SHOW;

    const handleFilterChange = (value) => {
        setToggle(value);
        setShowAll(false); // reset on filter change
    };

    return (
        <Container id="projects">
            <Wrapper>
                <Title>Projects</Title>
                <Desc>
                    A selection of projects I've built, from full-stack web apps to cloud infrastructure.
                </Desc>
                <ToggleButtonGroup>
                    {filterOptions.map((option, idx) => (
                        <React.Fragment key={option.value}>
                            {idx > 0 && <Divider />}
                            <ToggleButton
                                active={toggle === option.value}
                                onClick={() => handleFilterChange(option.value)}
                            >
                                {option.label}
                            </ToggleButton>
                        </React.Fragment>
                    ))}
                </ToggleButtonGroup>
                <CardContainer>
                    {visibleProjects.map((project, idx) => (
                        <AnimatedCard
                            key={project.id}
                            project={project}
                            setOpenModal={setOpenModal}
                            index={idx}
                        />
                    ))}
                </CardContainer>
                {!showAll && hiddenCount > 0 && (
                    <>
                        <ShowMoreButton onClick={() => setShowAll(true)}>
                            Show More Projects
                        </ShowMoreButton>
                        <ProjectCount>{hiddenCount} more project{hiddenCount > 1 ? 's' : ''}</ProjectCount>
                    </>
                )}
                {showAll && filteredProjects.length > INITIAL_SHOW && (
                    <ShowMoreButton onClick={() => setShowAll(false)}>
                        Show Less
                    </ShowMoreButton>
                )}
            </Wrapper>
        </Container>
    )
}

export default Projects
